import {Controller} from "stimulus"
import {openInspectionsMessage} from "./helpers/open_inspections_message"

export default class extends Controller {
    static targets = ["notifyCheckbox"]

    build(e) {
        this.appendNotifyParam(e);
        this.checkOpenInspections(e);
    }

    appendNotifyParam(e) {
        if (!this.hasNotifyCheckboxTarget) return;

        const link = e.currentTarget;
        const url = new URL(link.href, window.location.origin);
        const checked = this.notifyCheckboxTarget.checked;
        url.searchParams.set('notify_recipient', checked ? 'true' : 'false');
        link.href = url.toString();
    }

    checkOpenInspections(e) {
        const noticeTypeName = e.currentTarget.dataset.noticeType || '';
        if (!noticeTypeName.toLowerCase().includes('certificate of occupancy')) return;

        const inspectionsContainer = this.element.closest('[data-open-inspections]');
        if (!inspectionsContainer) return;

        const openInspections = JSON.parse(inspectionsContainer.dataset.openInspections || '[]');
        if (openInspections.length === 0) return;

        if (!window.confirm(openInspectionsMessage(openInspections))) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
}
